import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const exportAttendanceStatus = (data) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk diexport.");
    return;
  }

  const headerTitle = ['LAPORAN STATUS ABSENSI USER'];
  const headerDateNote = [`Tanggal Export: ${moment().format('DD/MM/YYYY HH:mm')}`];

  const headers = ['No', 'Users Code', 'Name', 'Status', 'Created At','Location (Name/Name Set)'];

  const rows = data.map((item, index) => [
    index + 1,
    item.users?.users_code || '',
    item.users?.name || '',
    item.is_anywhere ? 'Anywhere' : item.is_location_lock ? 'Lock Location' : 'All Locations',
    moment(item.created_at).format('YYYY-MM-DD HH:mm:ss'),
    item.attendance_location?.name_set || item.attendance_location?.name || '',
  ]);

  const worksheetData = [headerTitle, headerDateNote, headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Merge title and note
  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
    { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
  ];

  ws['A1'].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: 'center' },
  };

  ws['A2'].s = {
    font: { italic: true, sz: 12 },
    alignment: { horizontal: 'center' },
  };

  headers.forEach((_, idx) => {
    const colLetter = String.fromCharCode(65 + idx); // A, B, C, ...
    const cell = ws[`${colLetter}3`];
    if (cell) {
      cell.s = {
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: '4F81BD' } },
        border: {
          top: { style: 'thin', color: { auto: 1 } },
          bottom: { style: 'thin', color: { auto: 1 } },
          left: { style: 'thin', color: { auto: 1 } },
          right: { style: 'thin', color: { auto: 1 } },
        },
        alignment: { horizontal: 'center' },
      };
    }
  });

  const colWidths = [
    { wch: 5 },   // No
    { wch: 15 },  // Users Code
    { wch: 25 },  // Name
    { wch: 20 },  // Status
    { wch: 25 },  // Created At
    { wch: 25 },  // Created At
  ];
  ws['!cols'] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'User Status Attendance');

  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    `User_Status_Attendance_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
  );
};
